import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
import DropDownButton from '../buttons/DropDownButton';
import SplitButton from '../buttons/SplitButton';
import SplitButtonCascade from '../buttons/SplitButtonCascade';
import Print from './Print';
import flags from '../utils/flags';
import { buildUrl, isUserFilterActive } from '../utils/helper';
import './Toolbar.scss';

/**
 * Toolbar grid component
 * @module
 * @param {func} [onAdd] - Function invoked on entry add
 * @param {func} [onDelete] - Function invoked on entry delete
 * @param {func} [onCopy] - Function invoked on entry copy
 * @param {func} [onCancel] - Function invoked on entry cancel
 * @param {func} onRefresh - Function invoked on refresh
 * @param {func} onClear - Function invoked on clear
 * @param {element} [children] - Children element
 * @param {number} [disabled] - Flags for disabling actions
 * @param {number} [filterLength] - Filter length
 * @param {func} onSwitchFilterable - On switch filterable function
 * @param {number} [hidden] - Flags for hiding actions
 * @param {string} [imgName] - Image name
 * @param {func} onExport - Function invoked on file export
 * @param {func} [onPrint] - Function invoked on print
 * @param {func} onReset - Function invoked on reset
 * @param {func} onUpdateAll - Function invoked on update all entries
 * @param {func} onAbortChangesAll - Function invoked on abort all changes
 * @param {func} onEditAll - Function invoked on edit all entries
 * @param {array} selected - Selected entries
 * @param {bool} [showToolbarButtons] - Show buttons with labels (not icons)  in toolbar
 * @param {string} [customToolbarBreadcrumb] - display custom breadcrumb in toolbar
 */
class ToolbarComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      editingAll: (props.hidden & flags.EDITALL) === 0 ? false : undefined
    }
  }

  handlePrint = (index, name) => {
    this.props.onPrint(index, name);
  }

  handleEditAll = () => {
    this.setState({
      editingAll: true
    })
    this.props.onEditAll()
  }

  handleUpdateAll = () => {
    if (this.props.onUpdateAll()) {
      this.setState({
        editingAll: false
      });
    }

  }

  handleAbortChangesAll = () => {
    this.setState({
      editingAll: false
    })
    this.props.onAbortChangesAll()
  }

  handleFrmClick = (index, text) => {
    this.props.handleChangeFrm('frm', this.props.frms[index]);
  }

  getUserFilterList = () => {
    let userFilterList = this.props.userFilterList.map(x => {
      return { text: x.name, imageUrl: buildUrl(`assets/icons/${isUserFilterActive(this.props.filter.filters, x) ? "toolbar_filter-active" : "toolbar_cg_filter-add"}.svg`) }
    });
    if (this.props.predefinedFilterList.length > 0) {
      userFilterList.unshift({
        text: "Preddefinované filtre",
        disableClick: true,
        render: SplitButtonCascade,
        direction: "left",
        onItemClick: (value) => this.props.handleConfirmFilter(this.props.predefinedFilterList[value], true),
        items: this.props.predefinedFilterList.map(x => {
          return {
            text: x.name, imageUrl: buildUrl(`assets/icons/${this.props.filter.filters.find(f => f.filterId === x.id) ? 'toolbar_filter-active' : 'toolbar_cg_filter-add'}.svg`)
          }
        })
      })
    }
    return userFilterList;
  }

  render() {
    const isSelected = this.props.selected && this.props.selected.length === 1;
    const isMultiSelected = this.props.selected && this.props.selected.length >= 1;
    return (
      <>
        {this.props.customToolbarBreadcrumb ? (<span className="custom-breadcrumb">{this.props.customToolbarBreadcrumb}</span>) : null}
        <div id="grid-toolbar" className={`toolbar ${this.props.customToolbarBreadcrumb ? "custom-breadcrumb-no-margin" : ""}`}>
          {!(this.props.toolbarHidden || (this.props.hidden & flags.LEFT_TOOLBAR)) &&
            <span className="left">
              {this.props.showToolbarButtons && this.props.data && this.props.data.find((item) => item.hasChanged) && (
                <>
                  <Button onClick={this.handleUpdateAll} label="Uložiť zmeny" title="Uložiť zmeny" className="button-changes button-save-changes" />
                  <Button onClick={this.handleAbortChangesAll} label="Zrušiť zmeny" title="Zrušiť zmeny" className="button-changes button-cancel-changes" />
                </>
              )}
              {!(this.props.hidden & flags.ADD) &&
                <Button
                  onClick={this.props.onAdd}
                  primary={true}
                  disabled={this.props.disabled & (flags.ADD | flags.LEFT_TOOLBAR | flags.TOOLBAR)}
                  title="Nový záznam"
                  icon="novy-zaznam"
                  imageUrl={buildUrl('assets/icons/toolbar_cg_new.svg')}
                />
              }
              {!(this.props.hidden & flags.COPY) &&
                <Button
                  onClick={this.props.onCopy}
                  disabled={!isSelected || (this.props.disabled & (flags.COPY | flags.LEFT_TOOLBAR | flags.TOOLBAR))}
                  primary={true}
                  title="Nový záznam ako kópia"
                  imageUrl={buildUrl('assets/icons/toolbar_cg_copy.svg')}
                />
              }
              {!(this.props.hidden & flags.CANCEL) &&
                <Button
                  onClick={this.props.onCancel}
                  disabled={!isMultiSelected || (this.props.disabled & (flags.CANCEL | flags.LEFT_TOOLBAR | flags.TOOLBAR))}
                  primary={true}
                  icon="cancel"
                  title="Zrušenie záznamu"
                  imageUrl={buildUrl('assets/icons/toolbar_cg_cancel.svg')}
                />
              }
              {(this.props.hidden & flags.DELETE) !== flags.DELETE &&
                <Button
                  onClick={this.props.onDelete}
                  disabled={(((this.props.disabled & flags.DELETE) === flags.DELETE || !isSelected) && ((this.props.disabled & (flags.DELETEALL | flags.LEFT_TOOLBAR | flags.TOOLBAR) || this.props.selected.length === 0)))}
                  primary={true}
                  icon="delete"
                  title="Zmazanie záznamu"
                  imageUrl={buildUrl('assets/icons/toolbar_cg_delete.svg')}
                />
              }
              {(this.state.editingAll === false && (this.props.hidden & flags.EDITCELL) === 1) &&
                <Button
                  onClick={this.handleEditAll}
                  primary={true}
                  icon="track-changes-enable"
                  title="Upraviť všetky"
                  disabled={this.props.disabled & flags.TOOLBAR}
                />
              }
              {!this.props.showToolbarButtons && (this.state.editingAll === true || (this.props.hidden & flags.EDITCELL) === 0) &&
                <>
                  <Button
                    onClick={this.handleUpdateAll}
                    primary={true}
                    icon="track-changes-accept"
                    title="Uložiť zmeny"
                    disabled={this.props.disabled & flags.TOOLBAR}
                  />
                  <Button
                    onClick={this.handleAbortChangesAll}
                    primary={true}
                    icon="track-changes-reject"
                    title="Zrušiť úpravu"
                    disabled={this.props.disabled & flags.TOOLBAR}
                  />
                </>
              }
              {this.props.frms.length !== 0 &&
                <DropDownButton
                  text=""
                  title="Podradené formuláre"
                  imageUrl={buildUrl('assets/icons/toolbar_podriad_formular.svg')}
                  items={
                    this.props.frms.map(x => ({ text: x.Name, icon: "window", disabled: ((this.props.selected && this.props.selected.length > 1) && !x.MultiEnable) }))
                  }
                  onClick={this.handleFrmClick}
                  popupSettings={{ animate: false, popupClass: 'subform-button-popup' }}
                  disabled={!isMultiSelected}
                />
              }
              {(this.props?.children?.length ?? 0) !== 0 && <span className='delimeter'></span>}
              {this.props.children}
            </span>
          }
          <span className="right">
            {(!(this.props.hidden & flags.PRINT)) &&
              <Print
                disabled={Boolean(this.props.disabled & (flags.PRINT | flags.TOOLBAR))}
                printItems={this.props.printItems}
                onPrint={this.props.onPrint}
                tlac={this.props.tlac}
                onTlac={this.props.onTlac}
                isSelected={isSelected}
                isMultiSelected={isMultiSelected}
                reducer={this.props.reducer}
                componentFactory={this.props.componentFactory}
                selected={this.props.selected}
              />
            }
            {!(this.props.hidden & (flags.SORT_DIALOG | flags.SORT)) &&
              <Button
                onClick={this.props.handleOpenSort}
                primary={true}
                imageUrl={buildUrl('assets/icons/toolbar_zoradenie.svg')}
                title="Zoradenie"
                disabled={this.props.disabled & (flags.SORT | flags.SORT_DIALOG | flags.TOOLBAR)}
              />
            }
            {!(this.props.hidden & flags.SORT) &&
              <Button
                onClick={this.props.onSortClear}
                primary={true}
                imageUrl={buildUrl('assets/icons/toolbar_zrus_zoradenie.svg')}
                title="Zrušenie zoradenia"
                disabled={this.props.disabled & (flags.SORT | flags.TOOLBAR)}
              />
            }
            {(!(this.props.hidden & flags.FILTER)) &&
              <>
                {(this.props.userFilterList.length === 0 && this.props.predefinedFilterList.length === 0) ?
                  <Button
                    onClick={this.props.handleOpenFilter}
                    // imageUrl={this.props.filterLength > 0 ? buildUrl('assets/icons/toolbar_cg_filter-active.svg') : buildUrl('assets/icons/toolbar_cg_filter-add.svg')}
                    imageUrl={this.props.filterLength > 0 ? buildUrl('assets/icons/toolbar_filter-active.svg') : buildUrl('assets/icons/toolbar_filter-add.svg')}

                    title="Filter"
                    disabled={this.props.disabled & (flags.FILTER | flags.TOOLBAR)}
                  />
                  :
                  <SplitButton
                    className="compact-split-button"
                    onClick={(value) => value === -1 ? this.props.handleOpenFilter() : this.props.handleConfirmFilter(this.props.userFilterList[(this.props.predefinedFilterList.length > 0 ? value - 1 : value)], true)}
                    // imageUrl={this.props.filterLength > 0 ? buildUrl('assets/icons/toolbar_cg_filter-active.svg') : buildUrl('assets/icons/toolbar_cg_filter-add.svg')}
                    imageUrl={this.props.filterLength > 0 ? buildUrl('assets/icons/toolbar_filter-active.svg') : buildUrl('assets/icons/toolbar_filter-add.svg')}

                    title="Filter"
                    tooltip={this.props?.filter?.name ? `Aktívny filter: ${this.props.filter.name}` : "Filter"}
                    text=""
                    disabled={!!(this.props.disabled & (flags.FILTER | flags.TOOLBAR))}
                    popupSettings={{ animate: false }}
                    items={this.getUserFilterList()}
                    primary={true}
                  />
                }
                <Button
                  onClick={this.props.onClear}
                  icon="filter-clear"
                  title="Zrušenie filtra"
                  // imageUrl={buildUrl('assets/icons/toolbar_cg_filter.svg')}
                  imageUrl={buildUrl('assets/icons/toolbar_zrus_filter.svg')}
                  disabled={this.props.disabled & (flags.FILTER | flags.TOOLBAR)}
                />
                <Button
                  onClick={this.props.onSwitchFilterable}
                  imageUrl={this.props.filterable ? buildUrl('assets/icons/toolbar_cg_minimize.svg') : buildUrl('assets/icons/toolbar_cg_expand.svg')}
                  title="Mód"
                  disabled={this.props.disabled & (flags.FILTER | flags.TOOLBAR)}
                />
              </>
            }
            {!(this.props.hidden & flags.RESET) &&
              <SplitButton
                className="compact-split-button reset"
                onClick={(value) => this.props.onReset(value + 2)}
                imageUrl={buildUrl('assets/icons/toolbar_reset.svg')}
                title="Obnoviť vzhľad a zoradenie"
                tooltip="Obnoviť vzhľad a zoradenie"
                text=""
                disabled={!!(this.props.disabled & (flags.RESET | flags.TOOLBAR))}
                popupSettings={{ animate: false }}
                items={[{ text: "Obnoviť vzhľad", icon: "reset-sm" }, { text: "Obnoviť zoradenie", icon: "reset-sm" }]}
                primary
              />
            }
            {this.props.imgName &&
              <Button
                onClick={this.props.onExport}
                icon="image-export"
                title="Export"
                imageUrl={buildUrl('assets/icons/toolbar_cg_export.svg')}
                disabled={(this.props.disabled & flags.TOOLBAR)}
              />
            }
            <Button
              onClick={this.props.onRefresh}
              title="Aktualizovať údaje"
              imageUrl={buildUrl('assets/icons/toolbar_cg_refresh.svg')}
              disabled={this.props.disabled & flags.TOOLBAR}
            />
          </span>
        </div>
      </>
    );
  }
}

ToolbarComponent.propTypes = {
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  onCopy: PropTypes.func,
  onCancel: PropTypes.func,
  onRefresh: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  onSortClear: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
  ]),
  disabled: PropTypes.number,
  filterLength: PropTypes.number,
  onSwitchFilterable: PropTypes.func.isRequired,
  hidden: PropTypes.number,
  imgName: PropTypes.string,
  onExport: PropTypes.func.isRequired,
  onPrint: PropTypes.func,
  onReset: PropTypes.func.isRequired,
  onUpdateAll: PropTypes.func,
  onAbortChangesAll: PropTypes.func,
  onEditAll: PropTypes.func,
  selected: PropTypes.array.isRequired,
  handleOpenSort: PropTypes.func,
  showToolbarButtons: PropTypes.bool,
  customToolbarBreadcrumb: PropTypes.string,
  data: PropTypes.array,
  withMeta: PropTypes.bool,
  isPicker: PropTypes.bool,
  handleConfirmFilter: PropTypes.func,
  userFilterList: PropTypes.array,
  predefinedFilterList: PropTypes.array,
  reducer: PropTypes.func,
  componentFactory: PropTypes.func,
}

export default ToolbarComponent;